import { IconSource, IconSources } from '@src/assets/icons'
import { TerraProviderKind } from '@src/types'

// The Garmin Developer API Brand Guidelines require the full, unabbreviated
// "Garmin Connect™" name and the official Garmin Connect app tile wherever a
// user authenticates/connects the integration. These helpers override the
// user-facing branding on the connect screens only — the raw `provider.name`
// is still used for analytics, logging and error reporting.
const PROVIDER_BRAND_NAMES: Partial<Record<TerraProviderKind, string>> = {
  [TerraProviderKind.Garmin]: 'Garmin Connect™',
}

const PROVIDER_BRAND_ICONS: Partial<Record<TerraProviderKind, IconSource>> = {
  [TerraProviderKind.Garmin]: IconSources.garminConnect,
}

export const providerBrandName = (providerKind: TerraProviderKind, fallback: string) =>
  PROVIDER_BRAND_NAMES[providerKind] ?? fallback

export const providerBrandIcon = (
  providerKind: TerraProviderKind,
  fallback: IconSource,
): IconSource => PROVIDER_BRAND_ICONS[providerKind] ?? fallback

export const hasProviderBrand = (providerKind: TerraProviderKind) =>
  providerKind in PROVIDER_BRAND_NAMES
